import bannerImage from "../assets/images/banner-bg4.jpg";

export default function PageHeader({
    title,
    subtitle,
    backgroundImage = bannerImage,
}) {
    return (
        <section
            className="relative py-20 sm:py-24 lg:py-28 bg-cover bg-center"
            style={{
                backgroundImage: `url(${backgroundImage})`,
            }}
        >
            <div className="absolute inset-0 bg-black/60"></div>

            <div className="relative max-w-7xl mx-auto px-6 text-center text-white">
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">
                    {title}
                </h1>

                {subtitle && (
                    <p className="mt-3 sm:mt-4 text-sm sm:text-base text-white/80 max-w-2xl mx-auto">
                        {subtitle}
                    </p>
                )}
            </div>
        </section>
    );
}